import { render, staticRenderFns } from "./AdminContactUsMessagesView.vue?vue&type=template&id=7b712a46&scoped=true&"
import script from "./AdminContactUsMessagesView.vue?vue&type=script&lang=js&"
export * from "./AdminContactUsMessagesView.vue?vue&type=script&lang=js&"
import style0 from "./AdminContactUsMessagesView.vue?vue&type=style&index=0&id=7b712a46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b712a46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
